export default __webpack_public_path__ + "static/media/speechH.a3b24ba7.png";